import { isIn } from 'validator';

/**
 * Validates a parameter against a list of valid options.
 * Returns the parameter value if valid, undefined otherwise.
 * @param {string|null} param - The parameter value to validate.
 * @param {string[]} validOptions - Array of valid option values.
 * @returns {string|undefined} - The parameter if valid, undefined otherwise.
 * @example
 * // Returns 'DATA_GROUP_BY_COUNTERPARTY'
 * getValidatedQueryParam('DATA_GROUP_BY_COUNTERPARTY', GROUP_BY_OPTIONS);
 * @example
 * // Returns undefined (invalid value)
 * getValidatedQueryParam('INVALID_VALUE', GROUP_BY_OPTIONS);
 * @example
 * // Returns undefined (null input)
 * getValidatedQueryParam(null, GROUP_BY_OPTIONS);
 */
const getValidatedQueryParam = (param, validOptions) => (
  param && isIn(param, validOptions) ? param : undefined
);
export default getValidatedQueryParam;
